import { createCompoundComponent } from '@lounge-fe/ui-kit'

import { Navigation as BaseNavigation } from './Navigation'
import { HeaderComponent as Header } from './Header'

export const Navigation = createCompoundComponent(BaseNavigation, {
  Header,
})
